import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import TellUsAboutYourselfForm from './TellUsAboutYourselfForm';
import { postMemberTypeV2 } from '../../../actions/onboarding-actions';

import styles from '../nuoV2.scss';

const TellUsAboutYourself = () => {
    const [submitting] = useState();
    const dispatch = useDispatch();

    const handleSubmit = (values) => {
        let { memberTypeId } = values;
        const { subTypeId } = values;
        if (memberTypeId === 'coach') {
            memberTypeId = subTypeId;
        }
        dispatch(postMemberTypeV2({ memberTypeId }));
    };
    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.tell-us-about-yourself.title">
                Tell us a bit about yourself.
            </div>
            <TellUsAboutYourselfForm
                onSubmit={handleSubmit}
                submitting={submitting}
            />
        </div>
    );
};

export default TellUsAboutYourself;
